



























import { Component, Inject, Vue, Watch, Prop } from 'vue-property-decorator';
import { BaseApplicationController } from '@/services/request.service';

@Component
export default class BankInfoModal extends Vue {
  @Prop({ default: false }) public visible!: boolean;
  @Prop({ default: () => {} }) public data!: any;
  public loading: boolean = false;
  public errorList: any = {};
  public name: string = '';
  public code: string = '';

  @Watch('visible', { immediate: true })
  public resetData() {
    if (this.visible) {
      this.name = this.data.citicBankAccName || '';
      this.code = this.data.citicBankAccIdNum || '';
      this.errorList = {};
    }
  }

  public validator(): boolean {
    let result = true;
    if (!this.name || this.name.length > 50) {
      this.errorList = { ...this.errorList, nameError: 'nameInvaild' };
      result = false;
    }
    if (!this.code || this.code.length > 50) {
      this.errorList = { ...this.errorList, codeError: 'idNumberInvaild' };
      result = false;
    }
    return result;
  }

  public changeName(value: string): void {
    if (value) {
      this.errorList = { ...this.errorList, nameError: false };
    }
  }

  public changeCode(value: string): void {
    if (!value) {
      this.errorList = { ...this.errorList, codeError: false };
    }
  }

  public handleOk(): void {
    if (!this.validator()) {
      return;
    }
    this.loading = true;
    const request = {
      studentId: this.data.studentId,
      citicBankAccName: this.name,
      citicBankAccIdNum: this.code,
    };
    BaseApplicationController.addCiticBankInfo(request)
      .then(res => {
        this.$message.success(this.$tc('submitSuccess'));
        this.$emit('change', false);
        this.$emit('getData');
      })
      .finally(() => {
        this.loading = false;
      });
  }

  public handleCancel(): void {
    this.$emit('change', false);
  }
}
